import styles from "./Input.module.css";

function Input({
  label,
  width,
  required,
  children,
  forId,
  horizontal = false,
}) {
  return (
    <div
      className={horizontal ? styles.horizontal : styles.container}
      style={{ width: width }}
    >
      <label
        className={
          required ? `required-field ${styles.inputLabel}` : styles.inputLabel
        }
        htmlFor={forId}
      >
        {label}
      </label>
      {children}
    </div>
  );
}

export default Input;
